import { FloraTypography } from '@grupoboticario/flora-react'

import { asteriskStyle, fieldTitleStyle } from './FieldTitle.styles'

const FieldTitle = ({ children, isRequired = true }: { children: React.ReactNode; isRequired?: boolean }) => {
  return (
    <FloraTypography fontSize="bodyLargeStandard" fontWeight="regular" css={fieldTitleStyle}>
      {children}
      {isRequired && (
        <FloraTypography as="span" fontSize="bodyLargeStandard" css={asteriskStyle}>
          {' '}
          *
        </FloraTypography>
      )}
    </FloraTypography>
  )
}

export default FieldTitle
